<template>
  <!--  -->

  <v-card class="weather-card gm-card" rounded="xl" variant="outlined">
    <template #title>
      <div class="header">
        <div>天气</div>
        <div class="location">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          {{ currentWeather.place }}
        </div>
      </div>
    </template>

    <v-card-text>
      
      <div class="current-weather">
        <div>
          <span class="temp">{{ currentWeather.day_air_temperature ?? 0 }}°C</span>
          <span class="condition">{{ getWeatherNameCN(currentWeather.day_weather_code) }}</span>
          <div class="extra-info"><span>
  
              日出 {{ sun_begin_end[0] || '--' }}</span> <span>日落 {{ sun_begin_end[1] || '--' }}</span></div>
        </div>
        <div class="weather-icon" :class="getWeatherName(currentWeather.day_weather_code)"></div>
      </div>
  
      <v-divider class="my-4" color="var(--color-th-border)" opacity="1"></v-divider>
  
      <div class="forecast">
        <div class="day" v-for="day in next3Days" :key="day.name">
          <div class="day-name">{{ day.name }}</div>
          <div class="day-icon" :class="day.weatherName"></div>
        </div>
      </div>
    </v-card-text>
  </v-card>

</template>


<script setup>
import { inject, ref, computed, watch, reactive } from 'vue'
import request from '@/utils/request'
import dayjs from 'dayjs'
// import { setSunriseAndSunset } from '../data-share'

const sharedData = reactive({
  sunrise: '',
  sunset: '',
})




function setSunriseAndSunset(sunrise, sunset) {
  sharedData.sunrise = sunrise
  sharedData.sunset = sunset
}


const stationId = inject('stationId')
const weatherList = ref([])


const sun_begin_end = computed(() => {
  return getSunriseAndSunset()
})


function getSunriseAndSunset() {
  if (currentWeather.value.sun_begin_end) {
    return currentWeather.value.sun_begin_end.split('|')
  }
  return ['', '']
}


const currentWeather = computed(() => {
  if (weatherList.value.length > 0) {
    return weatherList.value[0]
  }
  return {}
})


const WeekDays = {
  0: '周日',
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
}

// 今天是周几
const currentWeekDay = computed(() => {
  return parseInt(dayjs().format('d'))
})

const next3Days = computed(() => {
  const today = currentWeekDay.value
  const days = []
  // 获取接下来三天（明天、后天、大后天）
  for (let i = 1; i <= 3; i++) {
    const dayIndex = (today + i) % 7
    const weekName = WeekDays[dayIndex]
    const weather = weatherList.value[i]
    let weatherName = 'Cloudy'
    if (weather) {
      weatherName = getWeatherName(weather.day_weather_code)
    }

    days.push({
      name: weekName,
      weatherName: weatherName,
    })
  }
  return days
})



const WeatherDataConfig = {
  0: '晴',
  1: '多云',
  2: '阴',
  3: '雨',
  4: '雪',
  5: '雾',
}

const WeatherEnNames = {
  0: 'Sunny',
  1: 'Cloudy',
  2: 'Overcast',
  3: 'Rain',
  4: 'Snow',
  5: 'Fog',
}

// "00": "晴", "01": "多云", "02": "阴", "03": "阵雨", "04": "雷阵雨",
// "05": "雷阵雨伴有冰雹", "06": "雨夹雪", "07": "小雨", "08": "中雨", "09": "大雨",
// "10": "暴雨", "11": "大暴雨", "12": "特大暴雨", "13": "阵雪", "14": "小雪",
// "15": "中雪", "16": "大雪", "17": "暴雪", "18": "雾", "19": "冻雨", "20": "沙尘暴",
// "21": "小到中雨", "22": "中到大雨", "23": "大到暴雨", "24": "暴雨到大暴雨",
// "25": "大暴雨到特大暴雨", "26": "小到中雪", "27": "中到大雪", "28": "大到暴雪", "29": "浮尘",
// "30": "扬沙", "31": "强沙尘暴", "32": "雨", "33": "雪", "53": "霾", "99": "无", "301": "雨", "302": "雪",
// "49": "强浓雾", "54": "中度霾", "55": "重度霾", "56": "严重霾", "57": "大雾", "58": "特强浓雾"
const maps = {
  0: ['00'],
  1: ['01'],
  2: ['02'],
  3: ['03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '19', '21', '22', '23', '24', '25', '32', '301'],
  4: ['06', '13', '14', '15', '16', '17', '25', '26', '27', '28', '33', '302'],
  5: ['18', '20', '29', '30', '31', '53', '49', '54', '55', '56', '57', '58'],
}


function getWeatherType(code) {
  for (const key in maps) {
    if (maps[key].includes(code)) {
      return key
    }
  }
  return null
}

function getWeatherName(code) {
  return WeatherEnNames[getWeatherType(code)]
}
function getWeatherNameCN(code) {
  return WeatherDataConfig[getWeatherType(code)]
}


function getWeather() {
  request({
    url: '/dashboard/v3/equipment/100C/queryWeather',
    method: 'get',
    params: {
      stationId: stationId.value
    }
  }).then(res => {
    weatherList.value = res.data


    const [sunrise, sunset] = getSunriseAndSunset()
    setSunriseAndSunset(sunrise, sunset)
  })
}
getWeather()


watch(stationId, () => {
  getWeather()
})



</script>


<style scoped lang="scss">
.weather-card {
  // padding: 20px;
  // border-radius: 16px;
  // border: 1px solid #DBE8F7;
  // background: linear-gradient(205deg, #C2E3FF -12.84%, rgba(255, 255, 255, 1) 80%);
  background: linear-gradient(204.52deg, #DBEBFF 12.08%, rgba(255, 255, 255, 0.22) 63.2%);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 20px;
  color: #212121;
}

.location {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.current-weather {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 20px;
}

.temp {
  font-size: 42px;
  font-weight: bold;
  color: #212121;
}

.condition {
  font-size: 20px;
  color: #616161;
  margin-left: 8px;
}



.extra-info {
  font-size: 12px;

  // font-weight: bold;
  >span {
    margin-left: 16px;
  }
}

.forecast {
  display: flex;
  justify-content: space-between;
}

.day {
  text-align: center;
}

.day-name {
  font-weight: 500;
  color: #212121;
  margin-bottom: 8px;
}

.day-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto;
  background: url(./img/cloudy.png) no-repeat center;
  background-size: contain;

  &.Sunny {
    background-image: url(./img/sunny.png);
  }

  &.Cloudy {
    background-image: url(./img/cloudy.png);
  }

  &.Overcast {
    background-image: url(./img/overcast.png);
  }

  &.Rain {
    background-image: url(./img/rain.png);
  }

  &.Snow {
    background-image: url(./img/snow.png);
  }

  &.Fog {
    background-image: url(./img/fog.png);
  }
}

.weather-icon {
  width: 100px;
  height: 100px;
  background: url(./img/main.png) no-repeat center;
  background-size: 100% 100%;

  &.Sunny {
    background-image: url(./img/sunny.png);
  }

  &.Cloudy {
    background-image: url(./img/cloudy.png);
  }

  &.Overcast {
    background-image: url(./img/overcast.png);
  }

  &.Rain {
    background-image: url(./img/rain.png);
  }

  &.Snow {
    background-image: url(./img/snow.png);
  }

  &.Fog {
    background-image: url(./img/fog.png);
  }
}
</style>
